/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_ReferenceInputs */

const en_search_domain_reference = /** @type {(inputs: Search_Domain_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the reference data`)
};

/**
* | output |
* | --- |
* | "the reference data" |
*
* @param {Search_Domain_ReferenceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_reference = /** @type {((inputs?: Search_Domain_ReferenceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_ReferenceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_reference(inputs)
});